import XApi from "../../utils/Api";
import XEndpoints from "../../core/config/Endpoints";

export class InventoryService {
    // Unit
    async addUnit({
                      name, symbol,
                  }: {
        name: string;
        symbol: string;
    }) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(XEndpoints.unit, {
                name,
                symbol,
            }, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async getUnit(id: number) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.unit}/detail/${id}`, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async updateUnit({id, name, symbol, status, deleted}: {
        id: number;
        name?: string;
        symbol?: string;
        status?: string;
        deleted?: boolean;
    }) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.patch(`${XEndpoints.unit}/detail/${id}`, {
                ...(name && {name}),
                ...(symbol && {symbol}),
                ...(status && {status}),
                ...(deleted && {deleted}),
            }, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async allUnits() {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.unit}/all`, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async exportUnit(data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(`${XEndpoints.unit}/export`, data, {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            });
            return response ?? null;
        }
        return null;
    }

    async uploadUnit(file: any, data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.upload(`${XEndpoints.unit}/upload`, {
                'Authorization': `Bearer ${token}`
            }, [file], data);
            return response ?? null;
        }
        return null;
    }

    // Category
    async addCategory({
                      name, image, parent
                  }: {
        name: string;
        image?: string;
        parent?: number;
    }) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(XEndpoints.category, {
                name,
                ...(image && {image}),
                ...(parent && {parent}),
            }, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async getCategory(id: number) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.category}/detail/${id}`, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async allCategories() {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.category}/all`, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async updateCategory({id, name, image, parent, status, deleted}: {
        id: number;
        name?: string;
        image?: string;
        parent?: number;
        status?: string;
        deleted?: boolean;
    }) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.patch(`${XEndpoints.category}/detail/${id}`, {
                ...(name && {name}),
                ...(image && {image}),
                ...(parent && {parent}),
                ...(status && {status}),
                ...(deleted && {deleted}),
            }, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async exportCategory(data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(`${XEndpoints.category}/export`, data, {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            });
            return response ?? null;
        }
        return null;
    }

    async uploadCategory(file: any, data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.upload(`${XEndpoints.category}/upload`, {
                'Authorization': `Bearer ${token}`
            }, [file], data);
            return response ?? null;
        }
        return null;
    }

    // Product
    async addProduct(data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(XEndpoints.product, data, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async getProduct(id: number) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.product}/detail/${id}`, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async updateProduct(id: number, data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.patch(`${XEndpoints.product}/detail/${id}`, data, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async deleteProductImage(id: number) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.product}/image/delete/${id}`, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async allProducts() {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.product}/all`, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? [];
        }
        return [];
    }

    async exportProduct(data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(`${XEndpoints.product}/export`, data, {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            });
            return response ?? null;
        }
        return null;
    }
}